import gql from 'graphql-tag';

export const getTenantDetailsQuery = gql(/* GraphQL */ `
  query getTenantDetails($tenantId: UUID!, $propertyId: UUID!) {
    tenant(tenantId: $tenantId, propertyId: $propertyId) {
      id
      name
      type
      propertyId
      relationships {
        id
        relatedToId
        type
      }
      channelDetails {
        id
        name
        type
        slug
        filters
        propertyLevelDomainControl
        stats {
          subscribers
          sf
        }
        created
        createdBy 
        updated
        updatedBy 
        address {
          order
          street1
          street2
          street3
          city
          state
          code
          country
          geo
        }
      }
    }
  } 
`);

